var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('v-btn',{attrs:{"color":"primary","text":"","dense":"","dark":"","block":""},on:{"click":_vm.download}},[_c('v-icon',[_vm._v("mdi-download")]),_vm._v(" Export CSV ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }